import {
  TaskAssignPayload,
  TaskResolvePayload,
  TaskSearchPayload,
  TaskStatusFilter,
} from '../models/task.interface';

export function createTasksSearchPayload(params: { pageSize: number; filter: { status: TaskStatusFilter }; continuationToken: string }): TaskSearchPayload {
  const payload: TaskSearchPayload = {
    pageSize: params.pageSize,
    includeTerminalStatuses: true,
  };
  if (params.filter.status !== TaskStatusFilter.All) payload.status = params.filter.status;
  if (params.continuationToken) payload.continuationToken = params.continuationToken;
  return payload;
}

export function createTaskAssignPayload(assigneeId: string): TaskAssignPayload {
  return { assigneeId };
}

export function createTaskResolvePayload(resolution: string): TaskResolvePayload {
  return { resolution };
}
